import ProjectReviews from './ProjectReviews'
export default class LuReviewType {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //Description is required
      Description: '',
      IsActive: null,
      SortOrder: null,
      Prefix: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.Description =  obj.Description
    this.IsActive = obj.IsActive
    this.SortOrder = obj.SortOrder
    this.Prefix = obj.Prefix

    this.ProjectReviews = []
    if (obj.ProjectReviews) {
      obj.ProjectReviews.forEach((item) => {
        this.ProjectReviews.push(new ProjectReviews(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.ProjectReviews = []
    if (this.ProjectReviews) {
      this.ProjectReviews.forEach((item) => {
        obj.ProjectReviews.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.ProjectReviews = null
    return obj
  }
}
